import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common_vi from "./translation/vi/translation.json"
import common_en from "./translation/en/translation.json"
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: 'translation',
    resources: {
      vi: {
        translation: common_vi
      },
      en: {
        translation: common_en
      },
    },
    lng: localStorage.getItem("i18nextLng")??"vi", // Ngôn ngữ mặc định
    fallbackLng: "vi", // Ngôn ngữ dự phòng
    interpolation: {
      escapeValue: false
    }
  });


export default i18n;